export const isNormalLink = (uri: string | null) =>
    typeof uri === 'string' && uri.startsWith('http');
